import { addYears, startOfDay, subDays, subYears } from 'date-fns';

/** Проверяет, валидна ли дата выдачи паспорта на день today */
export const validatePassportDate = (birthDate: Date, passportIssueDate: Date, today = startOfDay(new Date())) => {
  const AVAILABLE_CHANGE_DAYS = 90;
  // eslint-disable-next-line @typescript-eslint/init-declarations
  let minAvailablePassportIssueDate: Date;

  if (birthDate >= subDays(subYears(today, 20), AVAILABLE_CHANGE_DAYS)) {
    /** если возраст менее 20 лет */
    minAvailablePassportIssueDate = addYears(new Date(birthDate), 14);
  } else if (birthDate >= subDays(subYears(today, 45), AVAILABLE_CHANGE_DAYS)) {
    /** если возраст более 20 лет, но менее 45 */
    minAvailablePassportIssueDate = addYears(new Date(birthDate), 20);
  } else {
    /** если возраст более 45 лет */
    minAvailablePassportIssueDate = addYears(new Date(birthDate), 45);
  }

  return passportIssueDate >= minAvailablePassportIssueDate;
};
